"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grant = void 0;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Grant = React.memo(react_redux_1.connect((state) => ({
    auth: state.auth,
}))(({ auth, Component, scopes, Fallback }) => {
    return auth.verified &&
        auth.user &&
        (auth.user.scopes.includes('admin') || scopes.every(scope => auth.user.scopes.includes(scope)))
        ? Component
        : Fallback || null;
}));
exports.Grant = Grant;
